export default __webpack_public_path__ + "static/media/session7.010110dd.svg";